import { render, staticRenderFns } from "./pager.vue?vue&type=template&id=17eb8fed&scoped=true&"
import script from "./pager.vue?vue&type=script&lang=js&"
export * from "./pager.vue?vue&type=script&lang=js&"
import style0 from "./pager.vue?vue&type=style&index=0&id=17eb8fed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eb8fed",
  null
  
)

export default component.exports